var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg035Shield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.701,92.539L263.1,1.717c-5.179-2.299-11.092-2.29-16.263,0.03L44.233,92.569 c-7.177,3.218-11.796,10.349-11.796,18.214v157.692c0,59.596,23.551,120.517,64.615,167.142 c20.655,23.451,44.466,42.009,70.774,55.157C196.004,504.859,225.67,512,256,512c42.469,0,83.803-13.745,119.536-39.752 c8.914-6.487,10.881-18.971,4.393-27.885c-6.487-8.914-18.972-10.879-27.885-4.393c-28.862,21.006-62.073,32.108-96.043,32.108 c-96.111,0-183.641-97.044-183.641-203.602V123.711l182.683-81.892l184.599,81.944v144.713c0,36.757-10.559,73.956-30.537,107.574 c-5.632,9.477-2.515,21.725,6.962,27.357c9.479,5.631,21.726,2.514,27.358-6.963c23.643-39.785,36.139-84.035,36.139-127.967 V110.784C479.563,102.892,474.914,95.741,467.701,92.539z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg035Shield);
export default __webpack_public_path__ + "static/media/035-shield.c0bb3c05d41fe0fda359394f89d53ee8.svg";
export { ForwardRef as ReactComponent };